module.exports = __webpack_public_path__ + "static/mjs-google-drive-dcb8710a69e871990ddbaf068bd1907c.svg";